import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
  const [data, setData] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [showEditOptions, setShowEditOptions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return navigate('/giris');

    fetch('https://klima-backend-ggo2.onrender.com/api/admin/users-projects', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) throw new Error('Yetki yok veya sunucu hatası');
        return res.json();
      })
      .then(setData)
      .catch(() => {
        alert('Yetkisiz erişim veya oturum süresi doldu.');
        navigate('/giris');
      });
  }, [navigate]);

  const handleEditClick = (projectId) => {
    setSelectedProjectId(projectId);
    setShowEditOptions(true);
  };

  return (
    <div style={{ padding: 30 }}>
      <h2>🔐 Admin Paneli</h2>
      {data.map((user, idx) => (
        <div
          key={idx}
          style={{
            border: '1px solid #ccc',
            borderRadius: 6,
            marginBottom: 25,
            padding: 15,
            background: '#f9f9f9',
          }}
        >
          <h3>{user.username} ({user.email})</h3>
          {user.projects.length === 0 ? (
            <p style={{ fontStyle: 'italic', color: '#777' }}>Hiç proje kaydetmemiş.</p>
          ) : (
            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
              {user.projects.map((p, i) => (
                <li
                  key={p._id}
                  style={{
                    border: '1px solid #ddd',
                    borderRadius: 5,
                    padding: 10,
                    marginBottom: 10,
                    backgroundColor: '#fff',
                  }}
                >
                  <div>
                    <strong>{p.projectName}</strong> – {p.location}
                    <button
                      onClick={() => handleEditClick(p._id)}
                      style={{
                        marginLeft: 10,
                        padding: '4px 10px',
                        fontSize: '0.85rem',
                        borderRadius: 4,
                        border: 'none',
                        backgroundColor: '#4caf50',
                        color: 'white',
                        cursor: 'pointer'
                      }}
                    >
                      Düzenle
                    </button>
                    <span style={{
                      marginLeft: 10,
                      fontWeight: 'bold',
                      fontSize: '0.85rem',
                      color: p.offerRequested ? '#1976d2' : '#888'
                    }}>
                      {p.offerRequested ? '✓ Teklif İstendi' : 'Teklif İsteği Yok'}
                    </span>
                  </div>

                  {/* ✅ İletişim Bilgileri */}
                  {p.contact && (p.contact.company || p.contact.person || p.contact.phone) && (
                    <div style={{ marginTop: 8, fontSize: '0.85rem', color: '#444', paddingLeft: 10 }}>
                      {p.contact.company && <p><strong>Firma:</strong> {p.contact.company}</p>}
                      {p.contact.person && <p><strong>Yetkili:</strong> {p.contact.person}</p>}
                      {p.contact.phone && <p><strong>Telefon:</strong> {p.contact.phone}</p>}
                    </div>
                  )}

                  {/* Yüklenen dosyalar */}
                  {Array.isArray(p.uploadedFiles) && p.uploadedFiles.length > 0 && (
                    <ul style={{ marginTop: 8, marginLeft: 10, fontSize: '0.9rem' }}>
                      {p.uploadedFiles.map((file, j) => (
  <li key={j}>
    <a
      href={`https://klima-backend-ggo2.onrender.com/uploads/${file.serverName}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      📎 {file.originalName}
    </a>
  </li>
))}

                    </ul>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}

      {/* 🛠️ Cihaz Türü Seçim MODAL */}
      {showEditOptions && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999,
          }}
        >
          <div
            style={{
              backgroundColor: '#fff',
              padding: 30,
              borderRadius: 12,
              width: '90%',
              maxWidth: 420,
              textAlign: 'center',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
            }}
          >
            <h3 style={{ marginBottom: 15 }}>🛠️ Düzenlemek istediğiniz cihaz türünü seçin:</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button
                onClick={() => navigate(`/tasarim?edit=${selectedProjectId}`)}
                style={{
                  padding: '12px 18px',
                  backgroundColor: '#4caf50',
                  color: 'white',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 16,
                }}
              >
                🌬️ Klima Santrali Düzenle
              </button>
              <button
                onClick={() => navigate(`/igk?edit=${selectedProjectId}`)}
                style={{
                  padding: '12px 18px',
                  backgroundColor: '#03a9f4',
                  color: 'white',
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 16,
                }}
              >
                ♻️ IGK Cihazı Düzenle
              </button>

<button
  onClick={() => navigate(`/vrf?edit=${selectedProjectId}`)}
  style={{
    padding: '12px 18px',
    backgroundColor:  '#9c27b0', // 💜 mor ton
    color: 'white',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 16,
  }}
>
  🧊 VRF / VRV Sistemi Düzenle
</button>

              <button
  onClick={() => navigate(`/fan?edit=${selectedProjectId}`)}
  style={{
    padding: '12px 18px',
    backgroundColor: '#ff9800', // 🟠 turuncu ton
    color: 'white',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontSize: 16,
  }}
>
  🌀 Fan Grubu Düzenle
</button>

              <button
                onClick={() => setShowEditOptions(false)}
                style={{
                  marginTop: 10,
                  background: 'none',
                  border: 'none',
                  color: '#555',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontSize: 14,
                }}
              >
                Vazgeç
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPanel;
